import { returnNote as returnNoteEn } from '../en/returnNote';

export const returnNote = {
  ...returnNoteEn,
  returnNotes: 'திரும்பப்பெறும் குறிப்புகள்',
  allReturnNotes: 'அனைத்து திரும்பப்பெறும் குறிப்புகள்',
  createReturnNote: 'திரும்பப்பெறும் குறிப்பை உருவாக்கு',
  returnNoteDetails: 'திரும்பப்பெறும் குறிப்பு விவரங்கள்',
  status_completed: 'முடிந்தது',
  status_voided: 'ரத்து செய்யப்பட்டது',
  void: 'ரத்து செய்',
  voidReturnNote: 'திரும்பப்பெறும் குறிப்பை ரத்து செய்',
  creditNote: 'கடன் குறிப்பு',
  creditNoteRemaining: 'மீதமுள்ள இருப்பு',
  linkedCreditNotes: 'இணைக்கப்பட்ட கடன் குறிப்புகள்',
  confirmVoidReturnNote: 'இந்த திரும்பப்பெறும் குறிப்பை ரத்து செய்யவா? திரும்பிய இருப்பு மீண்டும் அகற்றப்படும், ஆர்டர் இருப்புத்தொகையும் நிலையும் மீண்டும் கணக்கிடப்படும், இந்த திரும்பப்பெறுதலின் கடன் குறிப்பு ரத்து செய்யப்படும். ஏற்கனவே வழங்கப்பட்ட பணத் திருப்பிச் செலுத்துதல்களை கைமுறையாக மீட்க வேண்டும்.',
  voidReason: 'ரத்து செய்வதற்கான காரணம்',
  voidReasonPlaceholder: 'ரத்து செய்வதற்கான காரணத்தை உள்ளிடவும்...',
  returnNoteVoidedSuccessfully: 'திரும்பப்பெறும் குறிப்பு வெற்றிகரமாக ரத்து செய்யப்பட்டது',
  failedToVoidReturnNote: 'திரும்பப்பெறும் குறிப்பை ரத்து செய்ய முடியவில்லை',
};
